<template>
    <nav class="menu">
        <h2 class="menu-title">{{ $t('components.menu.title') }}</h2>
        <p class="menu-desc">{{ $t('components.menu.description') }}</p>
        <ul class="menu-list">
            <li class="menu-list-item menu-list-item-countries">
                <router-link to="/countries" class="menu-list-link">
                    {{ $t('components.menu.countries') }}
                </router-link>
            </li>
            <li class="menu-list-item menu-list-item-checklists">
                <router-link to="/checklists" class="menu-list-link">
                    {{ $t('components.menu.checklists') }}
                </router-link>
            </li>
            <li class="menu-list-item menu-list-item-pppelements">
                <router-link to="/pppelements" class="menu-list-link">
                    {{ $t('components.menu.pppelements') }}
                </router-link>
            </li>
            <li class="menu-list-item menu-list-item-infopages">
                <router-link to="/infopages" class="menu-list-link">
                    {{ $t('components.menu.infopages') }}
                </router-link>
            </li>
            <li class="menu-list-item menu-list-item-statistics">
                <router-link to="/statistics" class="menu-list-link">
                    {{ $t('components.menu.statistics') }}
                </router-link>
            </li>
            <li class="menu-list-item menu-list-item-logs">
                <router-link to="/logs" class="menu-list-link">
                    {{ $t('components.menu.logs') }}
                </router-link>
            </li>
            <li class="menu-list-item menu-list-item-user-manual">
                <router-link to="/user-manual" class="menu-list-link">
                    {{ $t('components.menu.user-manual') }}
                </router-link>
            </li>
            <li class="menu-list-item menu-list-item-notifications">
                <router-link to="/notifications" class="menu-list-link">
                    {{ $t('components.menu.notifications') }}
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'Menu',
};
</script>
